import { PropsWithChildren, ReactNode } from 'react';
import { Layout } from '@repo/atomic-components';

type AppShellProps = PropsWithChildren<{
  /** Sidebar, outside the horizontal scroller so it never scrolls away. */
  sidebar?: ReactNode;
}>;

/**
 * Wraps every page. `html`/`body` never scroll; content scrolls below `--app-min-width` so nothing
 * is clipped at 200% zoom. The top spacer uses `--new-version-banner-h` set by `NewVersionBanner`.
 */
export const AppShell = ({ sidebar, children }: AppShellProps) => (
  <Layout>
    <div className="flex h-full w-full flex-col">
      <div style={{ height: 'var(--new-version-banner-h, 0px)', flexShrink: 0 }} />
      <div className="flex min-h-0 flex-auto">
        {sidebar}
        <div className="min-w-0 flex-auto overflow-auto">
          <div className="h-full w-full min-w-[var(--app-min-width)]">{children}</div>
        </div>
      </div>
    </div>
  </Layout>
);
